<div class="lg">
  <!-- ===================== LEFT: the identity panel ===================== -->
  <section class="lg-left">
    <header class="lg-mark">
      <span class="lg-shield" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
          <path d="M12 2 4 5v7c0 5 3.4 8.4 8 10 4.6-1.6 8-5 8-10V5l-8-3Z" />
          <path d="M9 12.5 11.2 15 15.5 10" stroke-linecap="round" />
        </svg>
      </span>

      <span class="lg-lockup">
        <span class="lg-wm"
          >{{ copy.markTop }}<span>{{ copy.markBottom }}</span></span
        >
        <span class="lg-wm-sub">{{ copy.markSub }}</span>
      </span>
    </header>

    <div class="lg-pitch">
      <h1 class="lg-display">
        {{ copy.headlineLine1 }}<br />
        {{ copy.headlineLine2 }}
      </h1>

      <p class="lg-body">{{ copy.body }}</p>
    </div>

    <footer class="lg-foot-left">
      <p>{{ copy.siteLine }}</p>
      <p>
        {{ copy.gatePassLabel }}
        <span class="lg-live" aria-hidden="true">●</span>
        <span class="lg-live">{{ copy.gatePassState }}</span>
      </p>
      <p>{{ release }} · {{ copy.referenceLine }}</p>
    </footer>
  </section>

  <!-- ===================== RIGHT: the sign-in panel ===================== -->
  <section class="lg-right">
    <!-- Pre-auth on purpose: ThemeService reads the attribute the inline
         bootstrap script already stamped, so the toggle needs no session. -->
    <div class="lg-toggle">
      <app-theme-toggle />
    </div>

    <div class="lg-panel">
      <h2 class="lg-h2">{{ copy.signInHeading }}</h2>
      <p class="lg-h2-sub">{{ copy.signInSub }}</p>

      <!--
        The METHOD switcher. The mockup showed three destination tiles
        (Command Centre / Response Team / Field Worker); the requirement is two
        login methods, and roles are chosen after sign-in from what the server
        grants. So the tiles keep their treatment and select a method instead -
        there is deliberately NO pre-auth role picker anywhere on this screen.
      -->
      <div class="lg-tiles" role="radiogroup" aria-label="Sign-in method">
        @for (tile of tiles; track tile.id) {
          <button
            type="button"
            role="radio"
            class="lg-tile"
            data-testid="method-tile"
            [class.on]="method() === tile.id"
            [attr.aria-checked]="method() === tile.id"
            [tabindex]="method() === tile.id ? 0 : -1"
            (click)="selectMethod(tile.id)"
            (keydown)="onTileKeydown($event, $index)"
          >
            <span class="lg-tile-icon" aria-hidden="true">
              @if (tile.id === 'password') {
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                  <rect x="4" y="10" width="16" height="10" rx="2" />
                  <path d="M8 10V7a4 4 0 0 1 8 0v3" />
                </svg>
              } @else {
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                  <rect x="6" y="2" width="12" height="20" rx="2.5" />
                  <path d="M10.5 18h3" stroke-linecap="round" />
                </svg>
              }
            </span>
            <span class="lg-tile-l1">{{ tile.line1 }}</span>
            <span class="lg-tile-l2">{{ tile.line2 }}</span>
          </button>
        }
      </div>

      @switch (method()) {
        @case ('password') {
          <app-password-login-form
            [busy]="passwordBusy()"
            [errorMessage]="passwordError()"
            (submitted)="onPasswordSubmit($event)"
            (forgotPassword)="onForgotPassword()"
          />
        }
        @case ('otp') {
          <app-otp-login-form
            [sending]="otpSending()"
            [verifying]="otpVerifying()"
            [errorMessage]="otpError()"
            [notice]="otpNotice()"
            [challenge]="otpChallenge()"
            (requestOtp)="onRequestOtp($event)"
            (submitted)="onOtpSubmit($event)"
          />
        }
      }

      <p class="note lg-foot-right">{{ copy.rightFooter }}</p>
    </div>
  </section>
</div>
